import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  FormField,
  FormLabel,
} from "@acdc2/ui/components/access-form";
import { PaginationArtifactType } from "../../client/generated";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@acdc2/ui/components/select";

type Props = ComponentProps<typeof Select>;

export function PaginationArtifactFormField(props: Props) {
  const { t } = useTranslation();

  return (
    <FormField name="artifact">
      <FormLabel>{t("PaginationArtifactFormField.label")}</FormLabel>
      <Select {...props}>
        <FormControl asChild>
          <SelectTrigger className="w-full">
            <SelectValue
              placeholder={t("PaginationArtifactFormField.placeholder")}
            />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          <SelectItem value={PaginationArtifactType.Header}>
            {t("PaginationArtifactFormField.options.header")}
          </SelectItem>
          <SelectItem value={PaginationArtifactType.Footer}>
            {t("PaginationArtifactFormField.options.footer")}
          </SelectItem>
          <SelectItem value={PaginationArtifactType.Watermark}>
            {t("PaginationArtifactFormField.options.watermark")}
          </SelectItem>
          <SelectItem value={PaginationArtifactType.PageNumber}>
            {t("PaginationArtifactFormField.options.pageNumber")}
          </SelectItem>
          <SelectItem value={PaginationArtifactType.BatesNumber}>
            {t("PaginationArtifactFormField.options.batesNumber")}
          </SelectItem>
          <SelectItem value={PaginationArtifactType.LineNumber}>
            {t("PaginationArtifactFormField.options.lineNumber")}
          </SelectItem>
          <SelectItem value={PaginationArtifactType.RedactionIndicator}>
            {t("PaginationArtifactFormField.options.redactionIndicator")}
          </SelectItem>
        </SelectContent>
      </Select>
    </FormField>
  );
}
